export const OPEN_SIDENAV = 'OPEN_SIDENAV';
export const CLOSE_SIDENAV = 'CLOSE_SIDENAV';
export const TOGGLE_SIDENAV = 'TOGGLE_SIDENAV';  // Example for toggling
export const SIDENAV_TYPE = 'SIDENAV_TYPE';
export const SIDENAV_COLOR = 'SIDENAV_COLOR';
export const TRANSPARENT_NAVBAR = 'TRANSPARENT_NAVBAR';
export const FIXED_NAVBAR = 'FIXED_NAVBAR';
export const OPEN_CONFIGURATOR = 'OPEN_CONFIGURATOR';
export const OPEN_CHAT = 'OPEN_CHAT';
export const CHANGE_APP = 'CHANGE_APP';
export const DEFAULT_APP = 'DEFAULT_APP';
